import { Menu } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { Glass } from '@/components/ui/glass'
import { routeTrail } from '@/lib/route-trail'

interface TopBarProps {
  showMenu?: boolean
  onMenuClick?: () => void
}

/** Floating Liquid Glass bar; the page scrolls under it. Account controls live in the sidebar footer. */
export default function TopBar({ showMenu = false, onMenuClick }: TopBarProps) {
  const known = routeTrail(useLocation().pathname)
  // An unknown path renders the 404 page; the bar should say so rather than sit empty.
  const trail = known.length ? known : ['Page not found']

  return (
    <div className="sticky top-[calc(env(safe-area-inset-top,0px)+0.75rem)] z-20 mx-4 mt-3 lg:mx-6">
      <Glass as="header" radius={28} className="flex h-14 items-center gap-2 pr-2 pl-2 lg:pl-5">
        {showMenu ? (
          <button type="button" className="glass-btn w-11 px-0 lg:hidden" onClick={onMenuClick} aria-label="Open menu">
            <Menu className="h-5 w-5" aria-hidden />
          </button>
        ) : null}

        {trail.length ? (
          <nav aria-label="Breadcrumb" className="min-w-0 truncate text-sm text-muted-foreground">
            <ol className="flex min-w-0 items-center gap-1.5">
              {trail.map((label, i) => {
                const last = i === trail.length - 1
                return (
                  <li key={label} className={last ? 'truncate font-semibold text-foreground' : 'shrink-0 max-sm:hidden'}>
                    {last ? <span aria-current="page">{label}</span> : label}
                    {last ? null : (
                      <span aria-hidden className="pl-1.5">
                        /
                      </span>
                    )}
                  </li>
                )
              })}
            </ol>
          </nav>
        ) : null}
      </Glass>
    </div>
  )
}
